import React from 'react'
import { Modal, Button } from 'react-bootstrap'
import Input from './input'
import ReactMixin from 'react-mixin'
import ImmutableRenderMixin from 'react-immutable-render-mixin'
import createLinkToImmutable from '_/utils/createLinkToImmutable'
import { List } from 'immutable'

/**
 * Bottom navigation component
 */
@ReactMixin.decorate(ImmutableRenderMixin)
class LandUseModal extends React.Component {
  static propTypes = {
    show: React.PropTypes.bool,
    property: React.PropTypes.object.isRequired,
    landUse: React.PropTypes.object.isRequired,
    onAdd: React.PropTypes.func.isRequired,
    onChange: React.PropTypes.func.isRequired,
    onRemove: React.PropTypes.func.isRequired,
    onHide: React.PropTypes.func
  }

  static contextTypes = {
    store: React.PropTypes.object
  }

  constructor(props, context) {
    super(props, context)
    this.state = {
      isNew: !props.landUse.has('id'),
      landUse: props.landUse,
      link: createLinkToImmutable(this, 'landUse')
    }
  }

  componentWillReceiveProps (props) {
    this.state = {
      isNew: !props.landUse.has('id'),
      landUse: props.landUse,
      link: createLinkToImmutable(this, 'landUse')
    }
  }

  async handleLandUse (evt) {
    evt.preventDefault()
    const { property, onAdd, onChange } = this.props
    const { landUse, isNew } = this.state
    const { store } = this.context

    try {
      if (isNew) {
        this.setState({ disableSubmit: true })
        const newLandUse = await store.post(`/properties/${property.get('id')}/landUse`, landUse)
        onAdd(newLandUse)
      }
      else {
        const updateLandUse = await store.post(`/properties/${property.get('id')}/landUse/${landUse.get('id')}`, landUse)
        onChange(updateLandUse)
      }
    } catch (er) {
      this.setState({
        errors: er.response.body.details
      })
    }

    this.setState({ disableSubmit: false })
  }

  async handleDelete (evt) {
    evt.preventDefault()
    const { property, onRemove } = this.props
    const { landUse } = this.state
    const { store } = this.context

    try {
      await store.delete(`/properties/${property.get('id')}/landUse/${landUse.get('id')}`)
      onRemove(landUse)
    } catch (er) {
      console.error(er)
      this.setState({
        errors: er.response.body.details
      })
    }
  }

  render () {
    const { show, onHide } = this.props
    const { link, isNew, disableSubmit } = this.state

    const enumValues = List(['Level', 'Undulating', 'Rolling', 'Sloping'])

    return (
      <Modal show={show} onHide={onHide}>
        <Modal.Header closeButton>
          <h3 className="modal-title">{isNew ? 'New' : 'Edit'} land use</h3>
        </Modal.Header>

        <Modal.Body>
          <Input
            label="Land use"
            type="text"
            valueLink={link('use')}
            name="use" />

          <Input
            label="Deeded acres"
            type="number"
            valueLink={link('deedAcresCt')}
            name="deedAcresCt" />

          <Input
            label="Topography"
            type="select"
            valueLink={link('topoT')}
            options={enumValues.map(v => ({
              value: v,
              label: v
            })).toJS()}
            name="deedAcresCt" />

          <Input
            label="Ratio"
            type="number"
            valueLink={link('ratioPct')}
            name="ratioPct" />

          <div className="pull-right">
            {!isNew &&
              <Button
                type="button"
                bsStyle="danger"
                onClick={::this.handleDelete}>
                Delete
              </Button>
            }
          </div>
          <Button
            type="submit"
            disabled={disableSubmit}
            bsStyle="info"
            onClick={::this.handleLandUse}>
            {isNew ? 'Create' : 'Update'} land use
          </Button>
        </Modal.Body>
      </Modal>
    )
  }
}

export default LandUseModal



// WEBPACK FOOTER //
// ./modules/shared/components/editLandUseModal.js